import { render, staticRenderFns } from "./ApprovalApproved.vue?vue&type=template&id=d7c5fdb6&"
import script from "./ApprovalApproved.vue?vue&type=script&lang=ts&"
export * from "./ApprovalApproved.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports